import { IAuctionStrategyInfo } from '../../../../repositories/billing-tariffs/entities/PublishTerms/AuctionStrategyInfo';
import { IAuctionStrategy } from '../../../../types/reducers/auction';
import { EServiceType } from '../../../../types/reducers/publishTerms';

export function mapAuctionStrategy(auctionStrategyInfo?: IAuctionStrategyInfo | null): IAuctionStrategy {
  const { isEnabled, serviceTypes, strategyName } = auctionStrategyInfo || {};

  return {
    isEnabled: isEnabled || false,
    serviceTypes: (serviceTypes as Array<string> as Array<EServiceType>) || [],
    strategyName: strategyName || '',
  };
}
